
namespace GeniuzPOS.QRreport {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class QRywcSpecDialog extends Serenity.EntityDialog<QRywcSpecRow, any> {
        protected getFormKey() { return QRywcSpecForm.formKey; }
        protected getIdProperty() { return QRywcSpecRow.idProperty; }
        protected getLocalTextPrefix() { return QRywcSpecRow.localTextPrefix; }
        protected getNameProperty() { return QRywcSpecRow.nameProperty; }
        protected getService() { return QRywcSpecService.baseUrl; }
        // protected getDeletePermission() { return QRywcSpecRow.deletePermission; }
        // protected getInsertPermission() { return QRywcSpecRow.insertPermission; }
        // protected getUpdatePermission() { return QRywcSpecRow.updatePermission; }

        protected form = new QRywcSpecForm(this.idPrefix);

        constructor() {
            super();
            

            this.form.ReportId.changeSelect2(e => {
                let ex = Q.toId(this.form.ReportId.value)
                // let fo =  this.form.ReportId.value
                // console.log(ex)

                // console.log(QRyreportRow.getLookup().itemById[fo].DataStructureName)
                if(ex !=null){
                this.form.DataStructureName.value = QRyreportRow.getLookup().itemById[ex].DataStructureName;
                this.form.ReportName.value = QRyreportRow.getLookup().itemById[ex].ReportName;
                this.form.UrlReport.value = QRyreportRow.getLookup().itemById[ex].UrlReport;
}
                // Serenity.ComponentModel
                
               
            });



        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );
            buttons.push(
                {
                    title: Q.text(" รายงาน"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-report',
                    icon: 'fa-report',
                    onClick: () => {
                        // this.dialogClose();
                        //let loggedinuser = localStorage.getItem("USERNAME");
                        let url = this.form.UrlReport.value;
                        window.location.href = url;
                        //window.open(url, '_blank');
                        // *** do something on click if you want **

                    },
                }
            );
            return buttons;
        }
        

    }

    
}